/** cart.guest.type member is probably also REGISTERED */
export function isRegisteredUserType(userType) {
  return !["CONTRACT", "TRADE", "ANONYMOUS", "GUEST"].includes(
    (userType || "").toUpperCase() ?? ""
  );
}
